import React, { Component } from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.css';
import './shards.css';
import './Welcome.css';
import { Redirect } from 'react-router';
import Main from './Main';
import {
  BrowserRouter as Router,
  Route,
  Link
} from 'react-router-dom';
import App from './App';
import './pairful-screenshot.png';







export default class Welcome extends React.Component {
	render() {

		return(
			<div className="welcome-screen">
				<div className="jumbotron jumbotron-fluid text-left bg-img text-light hero" style={{marginBottom: 0}}>
	 				<div className="container-fluid">
	 					<div className="row justify-content-center align-items-center">
			 				<div className="col-sm-12 col-md-8 col-lg-6" style={{marginBottom:60}} >
			    				<h1 className="display-4 text-light" >Spice up your relationship</h1>
			    				<p className="lead" style={{ marginBottom:20}}>The fun, risk-free way to find new toys that both you and your partner are dying to try out in the bedroom...</p>
			    				<Link to="/main" className="btn btn-light btn-lg" style={{color:'#2F80ED', marginRight:10, marginBottom:10}}>Get Started!</Link>
			    				<a href="#howitworks" className="btn btn-lg btn-outline-light text-light" style={{marginLeft:10, marginBottom: 10}}>How it works</a>
			    				
			  				</div>
			  				<div className=" col-lg-6 d-sm-none d-lg-flex ">
			  					<div className="col-sm-12">
			    					<img src="pairful-screenshot.png" className="img-fluid noDisplayPhone" alt="Responsive image"/>
			    				</div>
			  				</div>
			  			</div>
			  		</div>
				</div>
				<div id="howitworks" className="our-services section py-4" style={{marginTop:60}}>
			        <h3 className="section-title text-center my-5">How it Works</h3>
			        
			        <div className="features py-4 mb-4">
			          <div className="container">
			            <div className="row">
			              <div className="feature py-4 col-md-6 d-flex">
			                
			                <div className="px-4">
			                    <h5>Step 1</h5>
			                    <p>Choose from 15 of the most popular bedroom accessories and tell us which ones you would like to try</p>
			                </div>
			              </div>
			              <div className="feature py-4 col-md-6 d-flex">
			                
			                <div className="px-4">
			                    <h5>Step 2</h5>
			                    <p>Send a link to your partner for them to choose their favourites as well. Your partner cannot see how you answered</p>
			                </div>
			              </div>
			            </div>

			            <div className="row text-center justify-content-center">
			              <div className="feature py-4 col-md-6 d-flex justify-content-center">
			                
			                <div className="px-4">
			                    <h5>Step 3</h5>
			                    <p>When your partner has chosen their favourites, you can both see only the items which <b>you both liked</b></p>
			                </div>
			              </div>
			              <div className="feature py-4 col-md-6 d-flex text-center">
			                
			                <div className="px-4 text-center">
			                    <h5>Step 4</h5>
			                    <p>Talk together and see a link to buy the items in question... Next date night just became a bit more exciting!</p>
			                </div>
			              </div>
			            </div>
			          </div>
			        </div>
			        
			      </div>
				<div className="bg-dark">
					
	 					
	 					<div className="row justify-content-center text-center bg-light parallax" style={{marginTop: 0, height:200}}>
			 				<div className="col-sm-12 col-md-8 col-lg-8" style={{marginTop: 0}}>
			 				
			    				<h3 className="display-4 text-light" style={{marginTop:80, marginBottom:80}}>Try it out now <Link to="/main"><span className="btn btn-lg btn-primary" style={{marginLeft: 50}}>Spice it up!</span></Link></h3>
			    				
			    			
			  				</div>
			  			</div>
			  			
			  		</div>


			  		<footer className="text-muted bg-dark" >

				      <div  style={{paddingTop:80, paddingBottom:40, paddingRight:20, paddingLeft:20}}>
				        <p className="float-right small">
				          <a href="http://www.louisnicholls.com" style={{color:'#c1c1c1'}}>&copy; Louis Nicholls 2017</a>
				          
				        </p>
				        <p className="float-left small">
				          <a href="https://unsplash.com/photos/AsahNlC0VhQ" style={{color:'#c1c1c1'}}>Photo by Everton Vila at Unsplash</a>
				          
				        </p>
				        
				      </div>
				    </footer>
			</div>

			



		);
	}
	}


// WEBPACK FOOTER //
// ./src/Welcome.js